import { render } from "./suoluomenTable.vue?vue&type=template&id=c241e8d0&scoped=true"
import script from "./suoluomenTable.vue?vue&type=script&lang=js"
export * from "./suoluomenTable.vue?vue&type=script&lang=js"

import "./suoluomenTable.vue?vue&type=style&index=0&id=c241e8d0&lang=less&scoped=true"

import exportComponent from "/Users/ryancompany/works/bao/xinyuanyiyuan/pet-mobile-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c241e8d0"]])

export default __exports__